import { render, staticRenderFns } from "./legal_statement.vue?vue&type=template&id=dbef66ea&scoped=true&"
import script from "./legal_statement.vue?vue&type=script&lang=js&"
export * from "./legal_statement.vue?vue&type=script&lang=js&"
import style0 from "./legal_statement.vue?vue&type=style&index=0&id=dbef66ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef66ea",
  null
  
)

export default component.exports